import { createContext } from 'preact/compat';
import { genericOptionsDefaults } from '@widgets/GenericBookings/context/Options';
export const optionsDefaults = {
    ...genericOptionsDefaults,
    isWinterWonderland: false,
    vertical: false,
    productId: 217,
    showAvailability: false,
    showSessionAvailability: false,
    isMulti: false,
    isBuilder: false,
    requiresSignature: false,
};
export const OptionsCTX = createContext(optionsDefaults);
